<div
  class="alert"
  [class.alert--info]="variant() === 'info'"
  [class.alert--warning]="variant() === 'warning'">

  <!-- Info variant: center-aligned text only -->
  @if (variant() === 'info') {
    <div class="alert__content alert__content--center">
      <p class="alert__message">{{ message() }}</p>
    </div>
  }

  <!-- Warning variant: icon + left-aligned text -->
  @if (variant() === 'warning') {
    <div class="alert__content alert__content--with-icon">
      @if (iconClass()) {
        <i class="bi alert__icon" [ngClass]="iconClass()"></i>
      }

      <div class="alert__text-container">
        <p class="alert__message">{{ message() }}</p>
        @if (secondaryMessage()) {
          <p class="alert__secondary-message">{{ secondaryMessage() }}</p>
        }
      </div>
    </div>
  }
</div>
